// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2vK0B","file":"styles_file__3PtJ9"};